import { MDBContainer, MDBRow } from "mdb-react-ui-kit"
import { Outlet } from "react-router"

export const MediaContent = () => {

    return (
        <>
            <Outlet />
        </>
    )
}